'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' });

var Send = function Send(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Send = (0, _pure2.default)(Send);
Send.muiName = 'SvgIcon';

exports.default = Send;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Send.js
// module id = 2808
// module chunks = 0